import { render, staticRenderFns } from "./AttendanceReminders.vue?vue&type=template&id=607a0a9e&scoped=true"
import script from "./AttendanceReminders.vue?vue&type=script&lang=js"
export * from "./AttendanceReminders.vue?vue&type=script&lang=js"
import style0 from "./AttendanceReminders.vue?vue&type=style&index=0&id=607a0a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607a0a9e",
  null
  
)

export default component.exports